import { render, staticRenderFns } from "./MultipleAncestriesItem.vue?vue&type=template&id=5286acb1&scoped=true&"
import script from "./MultipleAncestriesItem.vue?vue&type=script&lang=js&"
export * from "./MultipleAncestriesItem.vue?vue&type=script&lang=js&"
import style0 from "./MultipleAncestriesItem.vue?vue&type=style&index=0&id=5286acb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5286acb1",
  null
  
)

export default component.exports